import React from 'react';
import { PageTitleZoneNext } from '../../../../components/page-title-zone';
import { getLessonStateDisplayValue } from '../../utils';
import { LessonStateDto } from '../../../../api-service/clients';

export interface ILessonTitlezoneProps {
  isEditMode: boolean;
  lessonState: LessonStateDto;
}

export function LessonTitlezone(props: ILessonTitlezoneProps) {
  const { isEditMode, lessonState } = props;
  const title = isEditMode ? (
    <span>
      Redigér lektion <span style={{ fontSize: '14px', fontWeight: 'normal' }}>({getLessonStateDisplayValue(lessonState)})</span>
    </span>
  ) : (
    'Opret lektion'
  );
  return <PageTitleZoneNext isLoading={false} entityName="Lektion" title={title} />;
}
